import BarChart from 'src/features/statistic/components/chart/BarChart';
import { DataKey, TransformedBarItem } from 'src/features/statistic/types';
import { GeneralBlock } from 'src/registry/components/blocks/GeneralBlock';
import { SectionBlockTitle } from 'src/registry/components/blocks/SectionBlock';
import { cn } from 'src/utils/shadcn';

type Props = {
    dataKeys: DataKey[];
    data: TransformedBarItem[];
    title: string;
    isLoading: boolean;
    className?: string;
};
export default function WidgetDurationBreakdown({ className, title, ...props }: Props) {
    return (
        <GeneralBlock className={cn('flex-1', className)}>
            <SectionBlockTitle>{title}</SectionBlockTitle>
            <BarChart {...props} />
        </GeneralBlock>
    );
}
